import { Injectable } from '@angular/core';

import { AuthGuardService } from '@shared/services';

@Injectable()
export class StoreAvailableAdjustmentPermission {
  constructor(protected authGuardService: AuthGuardService) {}

  public get hasApproveStoreAvailableAdjustment(): boolean {
    return this.authGuardService.checkPermission(['store_avai_adj_app']);
  }

  public get hasViewStoreAvailableAdjustmentRequest(): boolean {
    return this.authGuardService.checkPermission(['store_avai_adj_req_v']);
  }

  public get hasRegenerateApprovalWorkflow(): boolean {
    return this.authGuardService.checkPermission(['regen_app_workflow_m']);
  }
}
